module.exports = __webpack_public_path__ + "media/images/suppliers/ligatrap-242d7039e01c2e64ab7fdd624043bb3e.png";